

.container
{
  display: flex;
  flex-direction: column;
  align-items: end;
  .counter {
    font-size: 0.8em;
    color: gray;
  }
}
